module.exports = __webpack_public_path__ + "static/media/Configuración_Salario.0c2deb48.svg";